export default {
  AccountingIntegration: ['XeroIntegration', 'QboIntegration'],
  AccountingContact: ['QboCustomer', 'XeroContact'],
  IntegrationAccount: ['QboAccount', 'XeroAccount'],
};
